var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash-table-cell-wrapper',{attrs:{"placeholder":_vm.contextualPlaceholder,"highlighted":_vm.field.isHighlighted() && !_vm.isInherited,"inherited":_vm.isInherited,"indicator":_vm.indicator}},_vm._l((_vm.values),function(genre){return _c('tag',{key:genre.id,attrs:{"label":genre.name,"tag":_vm.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }